"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Overview/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _org = require('shared/selectors/org');
var _hooks = require('web/services/hooks');
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _useOrgAccount = require('shared/hooks/useOrgAccount');
var _keyboard = require('web/services/keyboard');

var _Form = require('web/components/Form');
var _Org = require('web/components/Settings/Org');
var _Headings = require('web/components/Settings/Headings');
var _AddOrgModal = require('./AddOrgModal'); var _AddOrgModal2 = _interopRequireDefault(_AddOrgModal);







const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`

// Account → Overview (screen 01): counts and every org, with Add organization.
const OverviewTab = ({ account, gotoOrgInfo, onAccountChanged }) => {
  const orgs = _hooks.useAppSelector.call(void 0, _org.selectOrgs)
  // null while loading; 'failed' shows a dash.
  const [peopleCount, setPeopleCount] = _react.useState(null)
  const [isAdding, setIsAdding] = _react.useState.call(void 0, false)
  // Someone removed or a role changed on People recounts (F-40).
  const [recounts, setRecounts] = _react.useState.call(void 0, 0)
  const recount = _react.useCallback.call(void 0, () => setRecounts(n => n + 1), [])
  _useBus2.default.call(void 0, _useOrgAccount.PEOPLE_CHANGES, recount)
  const { DefaultOrgKey, OrgKeys } = account

  _react.useEffect.call(void 0, 
    () => {
      let isCurrent = true
      _actions2.default.listAccountPeople({ OrgKey: DefaultOrgKey, CountOnly: true })
        .then(r => { if (isCurrent) setPeopleCount(r.Total) })
        .catch(() => { if (isCurrent) setPeopleCount('failed') })
      return () => { isCurrent = false }
    },
    [DefaultOrgKey, OrgKeys.length, recounts],
  )

  const onAddOrg = _react.useCallback.call(void 0, 
    (name) => _AddOrgModal.addAccountOrg.call(void 0, DefaultOrgKey, name).then(onAccountChanged),
    [DefaultOrgKey, onAccountChanged],
  )

  return (
    _react2.default.createElement(_Org.TabWrapper, { classNameSuffix: "account-overview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
      , _react2.default.createElement('div', { className: "settings--acct--cards", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
        , _react2.default.createElement('div', { className: "settings--acct--card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
          , _react2.default.createElement('span', { className: "settings--acct--card-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
            ,  peopleCount === null
              ? _react2.default.createElement('span', { className: "settings--skeleton-cell", role: "status", 'aria-label': "Loading people count"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}} )
              : peopleCount === 'failed' ? '-' : peopleCount 
          )
          , _react2.default.createElement('span', { className: "settings--acct--card-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "people")
        )
        , _react2.default.createElement('div', { className: "settings--acct--card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          , _react2.default.createElement('span', { className: "settings--acct--card-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}},  OrgKeys.length )
          , _react2.default.createElement('span', { className: "settings--acct--card-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, "organizations")
        )
      )
      , _react2.default.createElement('div', { className: "settings--acct--section-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
        , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "Organizations")
        , _react2.default.createElement(_Form.Button, { onClick: () => setIsAdding(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, "Add organization" )
      )
      , _react2.default.createElement('span', { className: "settings--orgs-list--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Every organization on this account. Owners and IT are members of each one."

      )
      , _react2.default.createElement('div', { role: "list", 'aria-label': "Organizations", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
        ,  OrgKeys.map(orgKey => {
          const org = orgs[orgKey]
          const details = [
            orgKey === DefaultOrgKey && 'Default',
            org && plural(_nullishCoalesce(org.NumberOfMembers, () => ( 0)), 'member', 'members'),
          ].filter(Boolean).join(' · ')
          return (
            _react2.default.createElement('div', {
              role: "listitem",
              key: orgKey,
              'aria-label': _optionalChain([org, 'optionalAccess', _ => _.Name]),
              className: "settings--orgs-list--btn settings--orgs-list--org" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}

              , _react2.default.createElement('div', {
                role: "button",
                tabIndex: 0,
                onKeyDown: _keyboard.onButtonKeyDown,
                onClick: () => gotoOrgInfo(orgKey),
                className: "settings--orgs-list--btn-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}

                , _react2.default.createElement('span', { className: "settings--orgs-list--btn-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}},  _nullishCoalesce(_optionalChain([org, 'optionalAccess', _2 => _2.Name]), () => ( 'Organization')) )
                ,  details && _react2.default.createElement('span', { className: "settings--acct--org-details", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}},  details ) 
                , _react2.default.createElement('div', { className: "settings--orgs-list--btn-next-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}} )
              )
            )
          )
        })
      )
      , _react2.default.createElement(_AddOrgModal2.default, { isOpen: isAdding, onClose: () => setIsAdding(false), onProceed: onAddOrg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}} )
    )
  )
}

exports. default = OverviewTab
